import { render, staticRenderFns } from "./primerPage.vue?vue&type=template&id=637d2b95&"
import script from "./primerPage.vue?vue&type=script&lang=js&"
export * from "./primerPage.vue?vue&type=script&lang=js&"
import style0 from "./primerPage.vue?vue&type=style&index=0&id=637d2b95&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports